import { Instance } from 'mobx-state-tree';
import { RouteOptimizingDtoModelBase } from './RouteOptimizingDtoModel.base';

/* The TypeScript type of an instance of RouteOptimizingDtoModel */
export interface RouteOptimizingDtoModelType extends Instance<typeof RouteOptimizingDtoModel.Type> {}

/* A graphql query fragment builders for RouteOptimizingDtoModel */
export { selectFromRouteOptimizingDto, routeOptimizingDtoModelPrimitives, RouteOptimizingDtoModelSelector } from './RouteOptimizingDtoModel.base';

/**
 * RouteOptimizingDtoModel
 */
export const RouteOptimizingDtoModel = RouteOptimizingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
